import type { OpenSearchStore } from "../types/products";

import { resolveOpenSearchStore } from "./resolve-opensearch-store";

type TreezStoreContextInput = {
    storeId: string;
    mso_org_id?: string;
    mso_store_entity_id?: string;
    configError?: string | null;
};

type OpenSearchStoreReadiness =
    | { status: "ready"; store: OpenSearchStore }
    | { status: "unconfigured_endpoint"; message: string }
    | { status: "unknown_store"; storeId: string }
    | { status: "config_fetch_error"; storeId: string; message: string }
    | { status: "missing_mso_ids"; storeId: string };

type GetOpenSearchStoreReadinessArgs = {
    storeId?: string | null;
    context: TreezStoreContextInput | undefined;
    configUnavailableReason?: string | null;
};

const DEFAULT_ENDPOINT_MESSAGE =
    "REACT_APP_OPEN_SEARCH_ENDPOINT is not set or invalid";

function getOpenSearchStoreReadiness({
    storeId,
    context,
    configUnavailableReason,
}: GetOpenSearchStoreReadinessArgs): OpenSearchStoreReadiness | null {
    const key = String(storeId ?? "").trim();
    if (!key) {
        return null;
    }

    if (configUnavailableReason) {
        return {
            status: "unconfigured_endpoint",
            message: configUnavailableReason,
        };
    }

    if (!context) {
        return { status: "unknown_store", storeId: key };
    }

    if (context.configError) {
        return {
            status: "config_fetch_error",
            storeId: key,
            message: context.configError,
        };
    }

    const store = resolveOpenSearchStore(key, context);
    if (!store) {
        return { status: "missing_mso_ids", storeId: key };
    }

    return { status: "ready", store };
}

export {
    DEFAULT_ENDPOINT_MESSAGE,
    getOpenSearchStoreReadiness,
    type GetOpenSearchStoreReadinessArgs,
    type OpenSearchStoreReadiness,
    type TreezStoreContextInput,
};
